// extracted by mini-css-extract-plugin
export default {"container":"events_container__1y-UJ","inner":"events_inner__r81tg","isContainer":"events_isContainer__28LOq"};